export class BlockPosition {
  type = '';
  top = 0;
  right = 0;
  bottom = 0;
  left = 0;
  zIndex = 1;

  static normalize(styles: Partial<BlockPosition>): BlockPosition {
    const blockPosition = new BlockPosition();

    blockPosition.type = styles.type ?? blockPosition.type;
    blockPosition.top = styles.top ?? blockPosition.top;
    blockPosition.right = styles.right ?? blockPosition.right;
    blockPosition.bottom = styles.bottom ?? blockPosition.bottom;
    blockPosition.left = styles.left ?? blockPosition.left;
    blockPosition.zIndex = styles.zIndex ?? blockPosition.zIndex;

    return blockPosition;
  }
}
